module.exports = __webpack_public_path__ + "img/4.78ea6f7e.png";